import React from 'react';
import { Flex, Image, Icon, Text } from '@chakra-ui/react';
import { MdLocationOn, MdLockOutline, MdPerson2 } from 'react-icons/md';
import { Group } from '../models/group';
import { useUser } from '../hooks/useUser';

interface GroupItemProps {
  group: Group;
}

const GroupItem: React.FC<GroupItemProps> = ({ group }) => {
  const owner = useUser(group.owner);
  return (
    <Flex
      justify="start"
      align="center"
      py="1rem"
      width="100%"
      borderBottom="1px solid #E8E8E8"
    >
      {group.thumbnail ? (
        <Image
          boxSize="105px"
          minW="105px"
          minH="105px"
          borderRadius="md"
          objectFit="cover"
          src={group.thumbnail}
          alt={`${group.name} thumbnail`}
        />
      ) : (
        <Flex
          flexDir="column"
          justifyContent="center"
          boxSize="105px"
          minW="105px"
          minH="105px"
          borderRadius="md"
          backgroundColor="#D9D9D9"
          textAlign="center"
        >
          No Image
        </Flex>
      )}
      <Flex ml="1rem" justifyContent="space-between" width="100%" height="100%">
        <Flex
          flexDir="column"
          flex={1}
          justifyContent="space-between"
          height="100%"
        >
          <Text flex={1} as="b" fontSize="18px" noOfLines={1}>
            {group.name}
          </Text>
          <Text mb="10px">{owner?.name}</Text>
          <Flex color="#8B8B8B" alignItems="center" fontWeight="semibold">
            <Icon as={MdLocationOn} />
            <Text fontSize="12px" mr="1rem">
              {group.location}
            </Text>
            <Icon as={MdPerson2} />
            <Text fontSize="12px">
              {group.members.length}/{group.total}
            </Text>
          </Flex>
        </Flex>
        {group.isPrivate && <Icon color="#858585" as={MdLockOutline} />}
      </Flex>
    </Flex>
  );
};

export default GroupItem;
